<template>
    <form v-if="hasAccess" action="" method="POST" @submit.prevent="save" class="max-w-sm mx-auto px-4 py-2">
        <top-nav-bar goto="/?page=requests"></top-nav-bar>

        <h3 class="text-center mb-8">Submit a new request</h3>

        <form-group label="Request Type" name="request_type" :required="true" v-if="!request_type || !has_type">
            <div class="select">
                <select v-model="request_type" id="request_type" class="input">
                    <option value="">Select a Request Type</option>
                    <option v-for="(name, slug) in requests" :value="slug">
                        {{name}}
                    </option>
                </select>
            </div>
        </form-group>

        <!-- Swap Requests -->
        <swap-request :start-date="start_date" :end-date="end_date" :attached-user="attached_employee_user"
                      v-if="request_type === 'buddy-flying' || request_type === 'duty-swap'"
                      :type="request_type"></swap-request>

        <!-- Pattern Flying -->
        <form-group label="Pattern Type" name="pattern_type" v-if="request_type === 'pattern-flying'"
                    help="Please describe pattern type.">
            <input id="pattern_type" type="text" class="input" name="pattern_type" v-model="pattern_type">
        </form-group>

        <!-- Leave Requests -->
        <leave-request :start-date="start_date" :end-date="end_date"
                       v-if="request_type === 'child-care-leave' || request_type === 'days-off' || request_type === 'reservist-service' || (request_type === 'pattern-flying' && pattern_type)"
                       :type="request_type"></leave-request>

        <div class="block md:inline-flex md:float-right" v-if="show_reason">
            <button class="btn btn--colored__green w-full" type="submit">
                <i class="fal fa-check"></i>
                {{saving ? 'Saving...' : 'Save'}}
            </button>
        </div>
    </form>
</template>

<script>
    import SwapRequest from '@/partials/SwapRequest.vue'
    import LeaveRequest from '@/partials/LeaveRequest.vue'
    import CanAccessView from "../mixins/CanAccessView";

    export default {
        mixins: [CanAccessView],
        components: {
            SwapRequest,
            LeaveRequest
        },
        props: {
            action: String,
            month: String,
            nextMonth: String,
            id: {
                default: null
            }
        },
        data() {
            return {
                has_type: false,
                request_type: '',
                pattern_type: '',
                start_date: '',
                end_date: '',
                attached_employee_user: '',
                reason: '',
                show_reason: false,
                saving: false,

                requests: [],
            }
        },

        mounted() {
            this.$api('hr').get('requests/create')
                .then(({data}) => {
                    this.requests = data.data.requests
                });

            this.$on('completed', () => {
                this.show_reason = true;
            });

            this.has_type = (typeof this.$route.params.type !== 'undefined');

            this.request_type = this.$route.params.type || '';

            var searchParams = new URLSearchParams(window.location.search);

            if (searchParams.get('type')) {
                this.request_type = searchParams.get('type');
            }

            if (searchParams.get('attached_employee_user')) {
                this.attached_employee_user = searchParams.get('attached_employee_user')
            }

            if (searchParams.get('start_date')) {
                this.start_date = searchParams.get('start_date')
            }

            if (searchParams.get('end_date')) {
                this.end_date = searchParams.get('end_date')
            }
        },

        methods: {
            toObject(form) {
                var obj = {};
                var elements = form.querySelectorAll("input, select, textarea");
                for (var i = 0; i < elements.length; ++i) {
                    var element = elements[i];
                    var name = element.name;
                    var value = element.value;

                    if (name) {
                        obj[name] = value;
                    }
                }

                return obj;
            },
            save(e) {
                this.$store.commit('setErrors', null)
                this.saving = true
                if (this.request_type) {
                    if (this.$store.state.connectionStatus === 'online') {
                        var form = new FormData(this.$el);
                        this.$api('hr', this).post('requests/' + this.request_type, form)
                            .then(response => {
                                this.saving = false
                                this.$router.push('/requests/list')
                            })
                    } else {
                        this.$pendingApi('requests', 'hr').post('requests/' + this.request_type, this.toObject(this.$el))
                            .then(response => {
                                this.saving = false
                                this.$router.push('/requests/list')
                            })
                    }
                } else {
                    this.$store.commit('setErrors', {errors: {'request_type': 'Please select a request type.'}})
                    this.saving = false
                }
            }

        },

        computed: {
            actionUrl() {
                var url = this.action;
                if (this.id) {
                    url += '/' + this.id;
                }
                if (this.request_type) {
                    url += '/' + this.request_type;
                }
                return url;
            }
        }

    }
</script>
